<template>
  <div class="login-page">
    <div class="login-bg-pattern"></div>
    <div class="login-container fade-in">
      <div class="login-header">
        <img class="logotipo" src="/logo-white.png" alt="logo">
      </div>
      <form class="login-box" @submit.prevent="login">
        <div class="login-title">
          <h2>Bem-vindo</h2>
          <p>Entre na sua conta para continuar</p>
        </div>

        <div class="field">
          <label class="label">Email</label>
          <div class="control has-icons-left">
            <input 
              class="input" 
              type="email" 
              placeholder="ex. cliente@exemplo.com" 
              v-model="email" 
              required
            >
            <span class="icon is-small is-left">
              <i class="fas fa-envelope"></i>
            </span>
          </div>
        </div>

        <div class="field">
          <div class="is-flex is-justify-content-space-between is-align-items-center">
            <label class="label mb-0">Password</label>
            <router-link to="/recoverpassword" class="forgot-link">Esqueceu a senha?</router-link>
          </div>
          <div class="control-wrapper">
            <div class="control has-icons-left">
              <input 
                class="input" 
                :type="showPassword ? 'text' : 'password'" 
                placeholder="********" 
                v-model="password" 
                required
              >
              <span class="icon is-small is-left">
                <i class="fas fa-lock"></i>
              </span>
            </div>
            <span 
              class="password-eye" 
              @click.stop="togglePassword"
              @mousedown.prevent
            >
              <i :class="showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
            </span>
          </div>
        </div>

        <div class="field mt-5">
          <button 
            class="button is-link is-fullwidth is-medium" 
            :class="{'is-loading':loading}"
          >
            Continuar
          </button>
        </div>
      </form>
      <div class="login-footer">
        <p>Não tem conta? <router-link to="/registration" class="has-text-white font-semibold">Registe-se</router-link></p>
        <p class="mt-2">
          <a href="https://www.goldylocks.pt" target="_blank" class="has-text-white font-semibold">
            Visitar site <i class="fas fa-external-link-alt ml-1"></i>
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      email: "",
      password: "",
      showPassword: false
    }
  },
  methods: {
    login() {
      this.loading = true;
      fetch(`/api/users/login`, {
        method: "POST",
        body: JSON.stringify({
          email: this.email,
          password: this.password
        })
      }).then(res => {
        return new Promise(((resolve, reject) => {
          if (res.status === 200) {
            res.json().then(userData => {
              localStorage.setItem('token', userData.token);
              localStorage.setItem('userData', JSON.stringify(userData));

              this.$store.commit('userData', userData);

              this.loading = false;

              this.$router.push('/dashboard');
            });
          } else {
            this.loading = false;
          }
        }))
      })
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    }
  },
}
</script>

<style scoped>
.login-page {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #0755A0 0%, #0F172A 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.login-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 1px, transparent 1px),
    radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
}

.login-container {
  width: 100%;
  max-width: 420px;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-header .logotipo {
  width: 260px;
  height: auto;
}

@media (max-width: 480px) {
  .login-header .logotipo {
    width: 280px;
    padding: 0.75rem 1rem;
  }
}

.login-box {
  background: var(--surface);
  border-radius: var(--radius-xl);
  padding: 2.5rem;
  box-shadow: var(--shadow-xl);
}

.login-title {
  text-align: center;
  margin-bottom: 2rem;
}

.login-title h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.login-title p {
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.field {
  margin-bottom: 1.5rem;
}

.login-box .label {
  margin-bottom: 0.5rem;
}

.login-box .input {
  height: 48px;
  font-size: 1rem;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.control-wrapper {
  position: relative;
}

.control-wrapper .control {
  width: 100%;
}

.password-eye {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 10;
  height: 48px;
  display: flex;
  align-items: center;
}

.password-eye:hover {
  color: var(--primary);
}

.login-box .input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(7, 85, 160, 0.15);
}

.login-box .icon {
  height: 48px;
  line-height: 48px;
}

.icon.is-right {
  cursor: pointer;
}

.icon.is-right:hover {
  color: var(--primary);
}

.forgot-link {
  font-size: 0.875rem;
  color: var(--primary);
}

.forgot-link:hover {
  text-decoration: underline;
}

.login-box .button {
  height: 48px;
  font-size: 1rem;
  font-weight: 600;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  border: none;
}

.login-box .button:hover {
  background: linear-gradient(135deg, var(--primary-dark) 0%, #042C57 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(7, 85, 160, 0.3);
}

.login-footer {
  text-align: center;
  margin-top: 1.5rem;
  color: rgba(255, 255, 255, 0.7);
}

.login-footer a {
  font-weight: 600;
}

.login-footer a:hover {
  text-decoration: underline;
}
</style>
